var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('Transition',{attrs:{"appear":""}},[_c('div',{class:_vm.$style.loadingIcon,attrs:{"name":"sync","spin":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }